// Backend Symphony Kontakt form  using this Controller
// DO NOT REMOVE !!!
import ControllerBase from '../../../../global/js/ControllerBase';

export default class ControllerAhuRequestKontakt extends ControllerBase {

  private maxLength = 10000;
  private selectID;
  private selectedValue;
  private textArea;
  private textAreaParent;
  private counter = 0;
  private className;

  constructor(element: HTMLElement) {
    super(element);
    this.counterHandler();
  }

  private counterHandler() {
    this.selectID = this.$element?.querySelector('#topic_contact_form_subject') as HTMLSelectElement | null;
    if (this.selectID) this.selectID?.addEventListener('change', (e: Event) => this.areaCounterHandler(e));
  }

  private areaCounterHandler(e) {
    this.selectedValue = e.target?.value;
    this.textArea = this.$element?.querySelector(`.ajax-form .js-select-tab[data-tab-id="${this.selectedValue}"] textarea`) as HTMLTextAreaElement;
    if (this.textArea) {
      this.textArea.setAttribute('maxlength', this.maxLength);
      this.textAreaParent = this.textArea.parentElement as HTMLElement;
      if (this.textAreaParent) {
        this.textAreaParent.setAttribute('data-counter', true);
        this.textAreaParent.setAttribute('char-counter', `0/${this.maxLength}`);
      }
      this.textArea.addEventListener('keyup', e => {
        this.counter = e?.target?.value?.length || 0;
        this.textAreaParent.setAttribute('char-counter', `${this.counter}/${this.maxLength}`);
        this.className = this.textAreaParent?.classList || ''
        if (this.counter >= (this.maxLength / 4 * 3) && this.counter < (this.maxLength / 12 * 11)) {
          this.className.add('text-warning');
          this.className.remove('text-danger');
        }
        else if (this.counter >= (this.maxLength / 12 * 11) && this.counter <= this.maxLength) {
          this.className.remove('text-warning');
          this.className.add('text-danger');
        }
        else {
          this.className.remove('text-warning');
          this.className.remove('text-danger');
        }
      });
    }
  }
}
